<template>
	<div>
		<ModalDestination ref="modalDestination"></ModalDestination>
		<v-row>
			<v-col cols="3" class="pt-0">
				<div class="font-size-14 font-weight-bold">Tambah Ekspedisi Baru</div>
			</v-col>
			<v-col cols="9" class="pt-0">
				<v-row>
					<v-col cols="6" class="pt-0 pb-1">
						<v-text-field outlined dense height="50" placeholder="Nomor Ekspedisi" color="primary lighten-1"></v-text-field>
					</v-col>
					<v-col cols="6" class="pt-0 pb-1">
						<v-autocomplete outlined dense height="50" class="input-expedition" placeholder="Pilih Armada" :items="armada" no-data-text="Tidak ada data" color="primary lighten-1"></v-autocomplete>
					</v-col>
					<v-col cols="6" class="pt-0 pb-1">
						<v-menu v-model="menu" :close-on-content-click="false" :nudge-right="35" transition="scale-transition" offset-y min-width="290px">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field placeholder="Tanggal Ekspedisi" outlined dense height="50" class="input-expedition" append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" v-model="date" clearable></v-text-field>
							</template>
							<v-date-picker locale="id" first-day-of-week="0" color="primary" :max="today" @input="menu = false" v-model="date"></v-date-picker>
						</v-menu>
					</v-col>
					<v-col cols="6" class="pt-0 pb-1">
						<v-autocomplete outlined dense height="50" class="input-expedition" placeholder="Pilih Driver" :items="driver" no-data-text="Tidak ada data" color="primary lighten-1"></v-autocomplete>
					</v-col>
					<v-col cols="6" class="pt-0 pb-1">
						<v-text-field outlined dense height="50" placeholder="PIC Ekspedisi" color="primary lighten-1"></v-text-field>
					</v-col>
					<v-col cols="6" class="pt-0 pb-1">
						<v-text-field outlined dense height="50" placeholder="Helper" color="primary lighten-1"></v-text-field>
					</v-col>
					<v-col cols="6" class="pt-0 pb-1">
						<v-text-field outlined dense height="50" placeholder="Saldo Transport" color="primary lighten-1" prefix="Rp"></v-text-field>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="3" class="pt-0">
				<div class="font-size-14 font-weight-bold">Destinasi Pengiriman</div>
			</v-col>
			<v-col cols="9" class="py-0">
				<v-row>
					<v-col cols="4" class="pt-0">
						<v-btn large depressed color="primary lighten-1" block @click.stop="showModalDestination">
							<div class="d-flex">
								<v-icon small>mdi-plus-circle</v-icon>
								<div class="pl-2 font-weight-bold text-capitalize">Tambah Destinasi</div>
							</div>
						</v-btn>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12">
						<div class="rounded overflow-hidden">
							<GmapMap :center="{ lat: -7.797068, lng: 110.3571025 }" :zoom="12"  style="width: 100%; height: 220px; border-radius: 8px">
							</GmapMap>
						</div>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="6">
						<v-card outlined class="px-3 py-2">
							<div class="d-flex justify-space-between">
								<div class="pt-3 font-size-10 font-weight-bold grey--text text--darken-2 title-destination-detail">Jumlah Destinasi</div>
								<div class="pt-1 font-size-18 font-weight-bold primary--text text--lighten-1">3</div>
							</div>
						</v-card>
					</v-col>
					<v-col cols="6">
						<v-card outlined class="px-3 py-2">
							<div class="d-flex justify-space-between">
								<div class="pt-3 font-size-10 font-weight-bold grey--text text--darken-2 title-destination-detail">Total Muatan</div>
								<div class="pt-1 font-size-18 font-weight-bold primary--text text--lighten-1">150</div>
							</div>
						</v-card>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12">
						<v-card outlined>
							<v-simple-table class="white-row">
								<template v-slot:default>
									<thead class="v-data-table-header">
										<tr>
											<th width="15%" class="text-left">No. Pengiriman</th>
											<th width="15%" class="text-left">No. Referensi</th>
											<th width="22%" class="text-left">Tujuan Pengiriman</th>
											<th width="14%" class="text-left">Estimasi Jarak</th>
											<th width="14%" class="text-left">Jumlah Muatan</th>
											<th width="10%" class="text-left">Aksi</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="i in 2" :key="i">
											<td>1000</td>
											<td>454545</td>
											<td>
												<div class="py-2">
													<div>Eko</div>
													<div>Bandung, Jawa Barat</div>
												</div>
											</td>
											<td>50 Km</td>
											<td>150</td>
											<td>
												<div class="d-flex">
													<v-tooltip bottom>
														<template v-slot:activator="{ on, attrs }">
															<div class="cursor-pointer mr-2" v-bind="attrs" v-on="on">
																<v-icon color="primary lighten-1">mdi-eye-outline</v-icon>
															</div>
														</template>
														<span>Detail</span>
													</v-tooltip>
													<v-tooltip bottom>
														<template v-slot:activator="{ on, attrs }">
															<div class="cursor-pointer" v-bind="attrs" v-on="on">
																<v-icon color="pink">mdi-delete-outline</v-icon>
															</div>
														</template>
														<span>Hapus</span>
													</v-tooltip>
												</div>
											</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-card>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12">
						<v-textarea outlined placeholder="Catatan Ekspedisi" color="primary lighten-1" no-resize height="110"></v-textarea>
					</v-col>
				</v-row>
				<v-row class="justify-center">
					<v-col cols="3" class="py-0">
						<v-btn large depressed color="primary lighten-1" block>
							<div class="pl-2 font-weight-bold text-capitalize">Simpan Ekspedisi</div>
						</v-btn>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import ModalDestination from './ModalDestination';

export default {
	components: {
		ModalDestination
	},
	data () {
		return {
			armada: ['Pick Up', 'Tronton'],
			driver: ['Rio', 'Eko'],
			helper: ['Supri'],
			menu: false,
			date: '',
			params: {
				id: '',
				username: '',
				password: '',
				passport : '',
				name : '',
				place_of_birth : '',
				date_of_birth: '',
				email: '',
				mobilephone: '',
				gender: '',
				address: ''
			},
		}
	},
	methods: {
		showModalDestination() {
			this.$refs.modalDestination.modalShow()
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Form Ekspedisi`)
	}
};

</script>